export const DatmanResellerPaymentsFilterTabs = {
    Successful: 'Sent',
    All: 'all'
};
